import { PENGUIN_PAD_BRAND_WALLET } from '@/lib/createGuard'

/** Official Penguin Pad Colony / admin wallet. */
export const OFFICIAL_COLONY_WALLET = '0x42D1CDB8A97d4446F9D6F10b341170abf16760e3'
export const OFFICIAL_COLONY_WALLET_PREFIX = '0x42d1'
export const OFFICIAL_COLONY_WALLET_SUFFIX = '60e3'

function normalizeWallet(wallet?: string | null) {
  return wallet?.trim().toLowerCase() || ''
}

export function isPenguinPadAdmin(wallet?: string | null): boolean {
  return normalizeWallet(wallet) === OFFICIAL_COLONY_WALLET.toLowerCase()
}

export function isOfficialPenguinPadAccount(wallet?: string | null): boolean {
  const address = normalizeWallet(wallet)
  if (!address.startsWith('0x') || address.length !== 42)
    return false
  if (address === PENGUIN_PAD_BRAND_WALLET.toLowerCase())
    return true
  return address === OFFICIAL_COLONY_WALLET.toLowerCase()
}
